import type { DeckKind } from './queries'

export const KIND_TITLE: Record<DeckKind, string> = { three_cards: 'Для 3 карт', daily_card: 'Для карты дня' }
export const KIND_LIVE: Record<DeckKind, string> = { three_cards: 'Сейчас в «Трёх картах»', daily_card: 'Сейчас в «Карте дня»' }
export const KINDS: readonly DeckKind[] = ['three_cards', 'daily_card']
export const KIND_SHORT: Record<DeckKind, string> = { daily_card: 'Карта дня', three_cards: 'Три карты' }
